var map = {
	"./index.js": 170,
	"./split-pane-mode.jsx": 320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;


//////////////////
// WEBPACK FOOTER
// ./src/core/plugins/split-pane-mode/components \.jsx?$
// module id = 1265
// module chunks = 0